import React from 'react'
import './Modal.css'

class Modal extends React.Component {
  handleClick(e) {
    if (e.target.id === "wrapper") {
      this.props.setWrapperState({modalOpen: false})
    }
  }
  render() {
    return (
      <div className="ModalWrapper" onClick={e => this.handleClick(e)} id="wrapper">
        <div className="Modal">
          <div className="innerModal">
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}

export default Modal
